'use client'

import React, { useEffect, useRef } from 'react'

const BroadstreetScript = ({ zoneId }) => {
  const adRef = useRef(null)
  const retryRef = useRef(null)

  useEffect(() => {
    const initAd = () => {
      if (!window.broadstreet) {
        // If Broadstreet isn't available yet, retry after a short delay
        retryRef.current = setTimeout(initAd, 100)
        return
      }

      if (retryRef.current) {
        clearTimeout(retryRef.current)
        retryRef.current = null
      }

      if (adRef.current) {
        const zoneElement = document.createElement('broadstreet-zone')
        zoneElement.setAttribute('zone-id', zoneId)
        zoneElement.setAttribute('soft-refresh', 'true')
        zoneElement.setAttribute('cache-life', '0')
        adRef.current.innerHTML = ''
        adRef.current.appendChild(zoneElement)
        window.broadstreet.watch({ 
          networkId: 9415,
          softRefresh: true,
          cacheLife: 0
        })
      }
    }

    // Initial attempt to initialize
    initAd()

    // Also initialize when broadstreet becomes ready
    window.addEventListener('broadstreetReady', initAd)

    return () => {
      if (retryRef.current) {
        clearTimeout(retryRef.current)
      }
      window.removeEventListener('broadstreetReady', initAd)
    }
  }, [zoneId])

  return <div ref={adRef} className="broadstreet-ad" />
}

export default BroadstreetScript
